var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandMerch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_24919)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.122 13.46l2.313 1.73a.719.719 0 01.285.57c0 .045-.016.154-.028.196l-.881 2.79 2.273-1.7a.698.698 0 01.836-.002l2.276 1.703-.876-2.771a1.046 1.046 0 01-.034-.217.72.72 0 01.28-.566l2.32-1.732H14.04a.703.703 0 01-.67-.492l-.867-2.744-.865 2.742a.703.703 0 01-.67.493H8.122zm.745 7.117a.497.497 0 01-.476-.65l1.28-4.059-3.353-2.508a.502.502 0 01-.175-.557.502.502 0 01.475-.343h4.132l1.275-4.048a.502.502 0 01.954 0l1.28 4.048h4.13a.501.501 0 01.3.9l-3.366 2.517 1.295 4.05a.5.5 0 01-.775.552l-3.34-2.497-3.336 2.497a.502.502 0 01-.3.099z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.363 22.86a.446.446 0 01-.319.14H1.964a.446.446 0 01-.32-.14.585.585 0 01-.15-.36l3.21-16.03c.019-.26.22-.47.46-.47h14.679c.241 0 .441.21.471.53l3.19 15.91c.009.16-.04.31-.141.42zM12.504 1c2.25 0 4.2 1.66 4.83 4H7.683c.631-2.34 2.571-4 4.821-4zm8.79 5.39c-.06-.78-.691-1.39-1.451-1.39h-1.48c-.659-2.91-3.06-5-5.859-5-2.8 0-5.18 2.09-5.84 5h-1.5c-.76 0-1.391.61-1.45 1.33L.504 22.37c-.031.43.12.85.41 1.17.269.29.65.46 1.05.46h21.08c.399 0 .78-.17 1.049-.46.291-.32.441-.74.401-1.23l-3.2-15.92z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_24919"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
}
SvgBrandMerch.displayName = 'BrandMerch';
export default SvgBrandMerch;